import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const STOP_EDITING_COMMENT = 'comment/STOP_EDITING';
export const stopEditingComment = createAction(STOP_EDITING_COMMENT);
